import { createRouter, createWebHistory } from 'vue-router';
import TicketsView from '../views/TicketsView.vue';
import WelcomeView from '../views/WelcomeView.vue';
import UserManagementView from '../views/UserManagementView.vue';
import UserFormView from '../views/UserFormView.vue';
import LoginView from '@/views/LoginView.vue';
import TokenExpiredView from '@/views/TokenExpiredView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import TableManagementView from '@/views/TableManagementView.vue';
import ManualView from '../views/ManualView.vue';

const routes = [

  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: WelcomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/tickets',
    name: 'Tickets',
    component: TicketsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagementView,
    meta: { requiresAuth: true, adminOnly: true }, // Solo accesible para administradores
  },
  {
    path: '/users/create',
    name: 'CreateUser',
    component: UserFormView,
    meta: { requiresAuth: true },
    props: { isEditMode: false },
  },
  {
    path: '/users/edit/:id',
    name: 'EditUser',
    component: UserFormView,
    meta: { requiresAuth: true },
    props: (route) => ({ isEditMode: true, userId: route.params.id }),
  },
  {
    path: '/manual',
    name: 'Manual',
    component: ManualView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manual',
    name: 'Manual',
    component: ManualView,
    meta: { requiresAuth: true }
  },
  {
    path: '/token-expired',
    name: 'TokenExpired',
    component: TokenExpiredView,
  },
  {
    path: '/tablas',
    name: 'TableManagement',
    component: TableManagementView,
    meta: { requiresAuth: true }
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
];

const router = createRouter({
  history: createWebHistory('/ticketagrovin/'), // <-- Aquí está el historial
  routes,
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('auth_token');
  // Debug: log navigation attempts
  try {
    if (import.meta.env && import.meta.env.DEV) console.debug('[Router] beforeEach to=', to.name || to.path, 'from=', from.name || from.path, 'token=', !!token, 'meta.adminOnly=', !!to.meta?.adminOnly);
  } catch (e) { if (import.meta.env && import.meta.env.DEV) console.warn('[Router] beforeEach log error', e); }

  if (to.name !== 'Login' && !token) {
    if (import.meta.env && import.meta.env.DEV) console.warn('[Router] no token, redirecting to Login');
    next({ name: 'Login' });
  } else {
    next();
  }
});

// afterEach to confirm final route
router.afterEach((to, from) => {
  try {
    if (import.meta.env && import.meta.env.DEV) console.debug('[Router] afterEach current route=', to.name || to.path);
  } catch (e) { if (import.meta.env && import.meta.env.DEV) console.warn('[Router] afterEach log error', e); }
});

export default router;